<button
  class="btn"
  [class]="classes.join(' ')"
  [disabled]="disabled"
  [type]="useSubmitBehavior ? 'submit' : 'button'"
  (click)="handleClick($event)"
>

  <as-icon
    *ngIf="showIcon"
    size="16"
  ></as-icon>
  <span *ngIf="showLabel" class="label-btn">{{ label }}</span>
</button>
